import { axios } from '../bootstrap';

export default {
  methods: {
    // Get the data for the widget
    $_commonOperations_getDataNew(url, params) {
      this.ui.loading = true;
      return axios.get(url, params);
    },
    $_commonOperations_putData(url, params) {
      this.ui.loading = true;
      return axios.put(url, params);
    },
    $_commonOperations_filterDataByDate(eventData) {
      let dateFilter;
      if (eventData.fromDate !== '' && eventData.toDate !== '') {
        dateFilter = {
          fromDate: eventData.fromDate,
          toDate: eventData.toDate,
        };
      }
      return dateFilter;
    },
    // Method that formats a date in YYYY-MM-DD format
    $_commonOperations_formatDate(value) {
      function pad(s) {
        return (s < 10) ? `0${s}` : s;
      }

      const d = new Date(value);
      return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
    },

    // Method that compares 2 json objects and returns true if different
    $_commonOperations_jsonNotEqual(a, b) {
      return JSON.stringify(a) !== JSON.stringify(b);
    },

    $_commonOperations_emitMessage(text, type) {
      this.$bus.$emit('displayMsg', {
        text,
        type,
      });
    },
  },
  filters: {
    commas(value) {
      if (!value) {
        return 0;
      }
      const parts = value.toString().split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },
  },
};
